/* SupraLash · Protocolo 90 Días — comportamiento de las secciones .sl90
   Cada módulo se engancha por atributo data-*, y se vuelve a montar cuando
   el editor de temas recarga una sección (shopify:section:load). */
(function () {
  'use strict';

  var MX = function (n) { return '$' + Math.round(n).toLocaleString('es-MX'); };

  function each(root, sel, fn) {
    Array.prototype.forEach.call(root.querySelectorAll(sel), fn);
  }

  /* ── revelado al entrar en pantalla ───────────────────────── */
  function initReveal(root) {
    var targets = root.querySelectorAll('.sl90 [data-sl90-reveal] > *');
    if (!targets.length) return;
    if (!('IntersectionObserver' in window)) {
      Array.prototype.forEach.call(targets, function (el) { el.classList.add('sl90-in'); });
      return;
    }
    var io = new IntersectionObserver(function (entries) {
      entries.forEach(function (e) {
        if (e.isIntersecting) { e.target.classList.add('sl90-in'); io.unobserve(e.target); }
      });
    }, { threshold: 0.08 });
    Array.prototype.forEach.call(targets, function (el) {
      el.classList.add('sl90-reveal');
      io.observe(el);
    });
  }

  /* ── marquesina de avisos ─────────────────────────────────── */
  function initAnnounce(root) {
    each(root, '[data-sl90-announce]', function (track) {
      if (track.dataset.slDone) return;
      track.innerHTML += track.innerHTML; // se duplica para que el loop no corte
      track.dataset.slDone = '1';
    });
  }

  /* ── "tu día 90 cae el ___" ───────────────────────────────── */
  function initDay90(root) {
    each(root, '[data-sl90-day90]', function (el) {
      var days = parseInt(el.dataset.sl90Day90, 10) || 90;
      var d = new Date();
      d.setDate(d.getDate() + days);
      el.textContent = d.toLocaleDateString('es-MX', { day: 'numeric', month: 'long', year: 'numeric' });
    });
  }

  /* ── calculadora de extensiones ───────────────────────────── */
  function initCalc(root) {
    each(root, '[data-sl90-calc]', function (box) {
      var ret = box.querySelector('[data-calc-ret]');
      var fre = box.querySelector('[data-calc-fre]');
      var ani = box.querySelector('[data-calc-ani]');
      if (!ret || !fre || !ani) return;
      var setInicial = parseFloat(box.dataset.setInicial) || 700;
      var precioAno1 = parseFloat(box.dataset.precioAno1) || 2890;
      var precioReposicion = parseFloat(box.dataset.precioReposicion) || 1926;
      var horasVisita = parseFloat(box.dataset.horasVisita) || 2;

      function paint(el) {
        el.style.setProperty('--sl-p', ((el.value - el.min) / (el.max - el.min) * 100) + '%');
      }
      function calc() {
        [ret, fre, ani].forEach(paint);
        var r = +ret.value, f = +fre.value, a = +ani.value;
        var visitas = Math.round(52 / f * a);
        var total = visitas * r + setInicial;
        box.querySelector('[data-calc-vret]').textContent = MX(r);
        box.querySelector('[data-calc-vfre]').textContent = f + (f === 1 ? ' semana' : ' semanas');
        box.querySelector('[data-calc-vani]').textContent = a + (a === 1 ? ' año' : ' años');
        box.querySelector('[data-calc-total]').textContent = MX(total);
        box.querySelector('[data-calc-horas]').textContent = Math.round(visitas * horasVisita) + ' horas';
        box.querySelector('[data-calc-sl]').textContent = MX(precioAno1 + Math.max(0, a - 1) * precioReposicion);
      }
      [ret, fre, ani].forEach(function (el) { el.addEventListener('input', calc); });
      calc();
    });
  }

  /* ── antes / después con manija ───────────────────────────── */
  function initBeforeAfter(root) {
    each(root, '[data-sl90-ba]', function (ba) {
      var after = ba.querySelector('[data-ba-after]');
      var handle = ba.querySelector('[data-ba-handle]');
      if (!after || !handle) return;
      var img = after.querySelector('img');
      var drag = false;

      function set(x) {
        var r = ba.getBoundingClientRect();
        var p = Math.max(0.03, Math.min(0.97, (x - r.left) / r.width));
        after.style.width = (p * 100) + '%';
        handle.style.left = (p * 100) + '%';
        if (img) img.style.width = r.width + 'px';
      }
      function size() { if (img) img.style.width = ba.getBoundingClientRect().width + 'px'; }

      handle.addEventListener('mousedown', function () { drag = true; });
      window.addEventListener('mouseup', function () { drag = false; });
      window.addEventListener('mousemove', function (e) { if (drag) set(e.clientX); });
      handle.addEventListener('touchstart', function () { drag = true; }, { passive: true });
      window.addEventListener('touchend', function () { drag = false; });
      window.addEventListener('touchmove', function (e) { if (drag) set(e.touches[0].clientX); }, { passive: true });
      ba.addEventListener('click', function (e) { if (e.target !== handle) set(e.clientX); });
      window.addEventListener('resize', size);
      var base = ba.querySelector('img');
      if (base && base.complete) size(); else if (base) base.onload = size;
      setTimeout(size, 400);
    });
  }

  /* ── selector de planes (landing de producto) ─────────────── */
  function initPlans(root) {
    each(root, '[data-sl90-plans]', function (box) {
      var inputs = box.querySelectorAll('input[type=radio]');
      var cta = box.querySelector('[data-plans-cta]');
      var msi = box.querySelector('[data-plans-msi]');
      var stack = document.querySelector('[data-sl90-stack]');
      var sticky = document.querySelector('[data-sl90-sticky]');
      if (!inputs.length) return;

      function apply(input) {
        Array.prototype.forEach.call(box.querySelectorAll('[data-plan]'), function (el) {
          el.classList.toggle('sl90p-on', el.contains(input));
        });
        if (cta) {
          cta.setAttribute('href', input.dataset.href);
          if (input.dataset.ctaLabel) {
            var label = cta.querySelector('[data-cta-label]');
            if (label) label.textContent = input.dataset.ctaLabel;
          }
        }
        if (msi && input.dataset.msi) msi.innerHTML = input.dataset.msi;
        if (stack) {
          Array.prototype.forEach.call(stack.querySelectorAll('[data-stack-plan]'), function (el) {
            el.hidden = el.dataset.stackPlan !== input.value;
            el.style.display = el.hidden ? 'none' : '';
          });
        }
        if (sticky) {
          var n = sticky.querySelector('[data-sticky-name]');
          var p = sticky.querySelector('[data-sticky-price]');
          var a = sticky.querySelector('[data-sticky-cta]');
          if (n) n.textContent = input.dataset.name;
          if (p) p.innerHTML = '<s>' + input.dataset.was + '</s> <b>' + input.dataset.price + '</b>';
          if (a) a.setAttribute('href', input.dataset.href);
        }
      }

      Array.prototype.forEach.call(inputs, function (input) {
        input.addEventListener('change', function () { apply(input); });
        if (input.checked) apply(input);
      });
    });
  }

  /* ── barra fija de compra ─────────────────────────────────── */
  function initSticky(root) {
    each(root, '[data-sl90-sticky]', function (bar) {
      var after = document.querySelector(bar.dataset.sl90Sticky || '');
      var lifted = [];

      // Los widgets de apps (WhatsApp, chat, volver arriba) viven pegados
      // abajo a la derecha y quedan debajo de la barra. Hay que subirlos —
      // y volver a buscarlos, porque varios entran tarde.
      function liftWidgets() {
        var h = bar.offsetHeight;
        Array.prototype.forEach.call(document.body.querySelectorAll('*'), function (el) {
          if (el === bar || bar.contains(el) || el.dataset.sl90Lifted) return;
          var cs = getComputedStyle(el);
          if (cs.position !== 'fixed') return;
          var bottom = parseFloat(cs.bottom);
          if (isNaN(bottom) || bottom > 140) return;
          // Las barras de ancho completo no se suben: se quedan detrás.
          // OJO: hay que medirlas cuando YA tienen ancho. La de Vitals
          // entraba midiendo 0 —todavía sin pintar—, colaba el filtro y
          // acababa subida ENCIMA de la nuestra en vez de debajo. Si aún
          // no mide nada, no se marca y se vuelve a mirar en la siguiente
          // pasada.
          var w = el.getBoundingClientRect().width;
          if (w < 1) return;
          if (w > window.innerWidth * 0.9) return;
          el.dataset.sl90Lifted = bottom;
          lifted.push(el);
        });
        lifted.forEach(function (el) {
          if (el.getBoundingClientRect().width > window.innerWidth * 0.9) return;
          el.style.bottom = (parseFloat(el.dataset.sl90Lifted) + h) + 'px';
        });
      }

      function onScroll() {
        var y = after ? after.getBoundingClientRect().bottom : 600;
        bar.classList.toggle('sl90p-show', y < 0);
      }
      window.addEventListener('scroll', onScroll, { passive: true });
      onScroll();
      // deja aire abajo para que la barra no tape el final de la página
      document.body.style.paddingBottom = bar.offsetHeight + 'px';
      liftWidgets();
      setTimeout(liftWidgets, 2500);
      setTimeout(liftWidgets, 6000);
    });
  }

  /* ── videos de la comunidad ───────────────────────────────
     Con sonido: el play nace de un clic, así que el navegador lo
     permite. Si aun así lo bloquea, cae a silencio y sigue. */
  function initUgc(root) {
    each(root, '.sl90h-ugc-i', function (box) {
      var v = box.querySelector('video');
      if (!v || v.dataset.slListo) return;
      v.dataset.slListo = '1';

      var btn = box.querySelector('.sl90h-ugc-play');
      var son = box.querySelector('.sl90h-ugc-sound');
      var icoPlay = box.querySelector('.sl90h-ico-play');
      var icoPausa = box.querySelector('.sl90h-ico-pausa');
      var onda = box.querySelector('.sl90h-onda');
      var tache = box.querySelector('.sl90h-tache');

      function pintaSonido() {
        if (onda) onda.style.display = v.muted ? 'none' : '';
        if (tache) tache.style.display = v.muted ? '' : 'none';
        if (son) son.setAttribute('aria-label', v.muted ? 'Activar sonido' : 'Silenciar');
      }
      function pintaBoton() {
        var sonando = !v.paused;
        if (icoPlay) icoPlay.style.display = sonando ? 'none' : '';
        if (icoPausa) icoPausa.style.display = sonando ? '' : 'none';
        if (btn) btn.setAttribute('aria-label', sonando ? 'Pausar' : 'Reproducir');
        box.classList.toggle('sl90h-suena', sonando);
        if (son) son.style.display = sonando ? '' : 'none';
      }
      function reproduce() {
        each(document, '.sl90h-ugc-i video', function (o) { if (o !== v) o.pause(); });
        var p = v.play();
        if (p && p.catch) p.catch(function () { v.muted = true; pintaSonido(); v.play(); });
      }
      function alterna() { if (v.paused) reproduce(); else v.pause(); }

      v.addEventListener('click', alterna);
      if (btn) btn.addEventListener('click', function (e) { e.stopPropagation(); alterna(); });
      if (son) son.addEventListener('click', function (e) {
        e.stopPropagation();
        v.muted = !v.muted;
        pintaSonido();
      });
      v.addEventListener('play', pintaBoton);
      v.addEventListener('pause', pintaBoton);
      v.addEventListener('ended', pintaBoton);

      if (son) son.removeAttribute('hidden');
      pintaSonido();
      pintaBoton();
    });
  }

  /* ── carrusel horizontal ──────────────────────────────────────
     Uno genérico por atributo. Las "páginas" se calculan del ancho real
     del riel, así que los puntos salen bien tanto con 1 tarjeta a la
     vista en móvil como con 3 en escritorio, sin números escritos a mano. */
  function initCarrusel(root) {
    each(root, '[data-sl90-carrusel]', function (car) {
      var riel = car.querySelector('[data-carrusel-riel]');
      var puntos = car.querySelector('[data-carrusel-puntos]');
      var prev = car.querySelector('[data-carrusel-prev]');
      var next = car.querySelector('[data-carrusel-next]');
      if (!riel) return;

      function paso() {
        var uno = riel.firstElementChild;
        if (!uno) return riel.clientWidth;
        var g = parseFloat(getComputedStyle(riel).columnGap || '0') || 0;
        return uno.getBoundingClientRect().width + g;
      }

      function paginas() {
        return Math.max(1, Math.round(riel.scrollWidth / Math.max(1, riel.clientWidth)));
      }

      function pintarPuntos() {
        if (!puntos) return;
        var n = paginas();
        // con todo a la vista el carrusel sobra: se esconden los mandos
        car.classList.toggle('sl90-carrusel--quieto', n < 2);
        if (puntos.childElementCount === n) return sincronizar();
        puntos.innerHTML = '';
        for (var i = 0; i < n; i++) {
          var b = document.createElement('button');
          b.type = 'button';
          b.className = 'sl90-carrusel-punto';
          b.setAttribute('aria-label', 'Ir al grupo ' + (i + 1) + ' de ' + n);
          (function (idx) {
            b.addEventListener('click', function () {
              riel.scrollTo({ left: idx * riel.clientWidth, behavior: 'smooth' });
            });
          })(i);
          puntos.appendChild(b);
        }
        sincronizar();
      }

      function sincronizar() {
        if (puntos && puntos.childElementCount) {
          var i = Math.round(riel.scrollLeft / Math.max(1, riel.clientWidth));
          Array.prototype.forEach.call(puntos.children, function (b, k) {
            b.classList.toggle('sl90-carrusel-punto--on', k === i);
          });
        }
        var fin = riel.scrollWidth - riel.clientWidth - 2;
        if (prev) prev.disabled = riel.scrollLeft <= 2;
        if (next) next.disabled = riel.scrollLeft >= fin;
      }

      if (prev) prev.addEventListener('click', function () { riel.scrollBy({ left: -paso(), behavior: 'smooth' }); });
      if (next) next.addEventListener('click', function () { riel.scrollBy({ left: paso(), behavior: 'smooth' }); });
      riel.addEventListener('scroll', sincronizar, { passive: true });
      window.addEventListener('resize', pintarPuntos);
      // las fotos entran perezosas y cambian el scrollWidth: hay que recontar
      each(riel, 'img', function (im) { im.addEventListener('load', pintarPuntos); });
      pintarPuntos();
    });
  }

  /* ── galería de producto ──────────────────────────────────── */
  function initGallery(root) {
    each(root, '[data-sl90-gallery]', function (gal) {
      var main = gal.querySelector('[data-gal-main]');
      each(gal, '[data-gal-thumb]', function (btn) {
        btn.addEventListener('click', function () {
          each(gal, '[data-gal-thumb]', function (b) { b.classList.remove('sl90p-on'); });
          btn.classList.add('sl90p-on');
          if (main) {
            main.src = btn.dataset.galThumb;
            main.alt = btn.querySelector('img') ? btn.querySelector('img').alt : main.alt;
          }
        });
      });
    });
  }

  function init(root) {
    root = root || document;
    initReveal(root);
    initAnnounce(root);
    initDay90(root);
    initCalc(root);
    initBeforeAfter(root);
    initPlans(root);
    initSticky(root);
    initUgc(root);
    initGallery(root);
    initCarrusel(root);
  }

  if (document.readyState === 'loading') {
    document.addEventListener('DOMContentLoaded', function () { init(document); });
  } else {
    init(document);
  }
  document.addEventListener('shopify:section:load', function (e) { init(e.target); });
})();
